import valid from 'card-validator'
import creditCardType from 'credit-card-type'
import { IntlShape } from 'react-intl'

export const creditCardFormSchema = {
  number: '',
  expMonth: '',
  expYear: '',
  cvv: '',
  saveCreditCard: false
}

export interface CreditCardFormValues {
  number: string
  expMonth: string
  expYear: string
  cvv: string
  saveCreditCard: boolean
}

export const creditCardFormValidation = (intl: IntlShape) => (values: CreditCardFormValues) => {
  const { formatMessage } = intl
  const {
    number, expMonth, expYear, cvv
  } = values
  const errors: Record<string, string> = {}

  const [card] = creditCardType(number)
  const cvvLength = card?.code?.size
  const numberValidation = valid.number(number)
  const monthValidation = valid.expirationMonth(expMonth)
  const yearValidation = valid.expirationYear(expYear)
  const cvvValidation = valid.cvv(cvv, cvvLength)

  if (!numberValidation.isValid) {
    errors.number = formatMessage({ id: 'checkout.billing.ccForm.validation.numberValid' })
  }

  if (!monthValidation.isValid) {
    errors.expMonth = formatMessage({ id: 'checkout.billing.ccForm.validation.expMonthValid' })
  }

  if (!yearValidation.isValid) {
    errors.expYear = formatMessage({ id: 'checkout.billing.ccForm.validation.expYearValid' })
  }

  if (!cvvValidation.isValid) {
    errors.cvv = formatMessage({ id: 'checkout.billing.ccForm.validation.cvvValid' })
  }

  return errors
}
